import qq from 'fine-uploader'

const UploadObject = context => {
  let _uploader = null
  const _u = {
    submits: [],
    status: 'idle',
    uploaded: 0,
    handle: null
  }
  function _done() {
    /**
     * This will fire after the return false from _upload().
     * If complete, reset the uploader.
     */
    if (_u.status === 'complete') {
      _uploader.reset()
      _u.submits = []
      _u.status = 'idle'
      _u.uploaded = 0
    }
  }
  function _next() {
    /**
     * Increase uploaded.
     * When all submits are proceeded set status to complete.
     */
    if (_u.uploaded++ >= _uploader.getUploads().length - 1) {
      _u.status = 'complete'
    }
  }
  function _upload() {
    /**
     * NOTE:  onSubmit runs for every dropped file.
     *        Returning false tells the uploader not to proceed the submitted files by fineUploader,
     *        so we can upload them ourselves.
     */
    if (_u.status === 'idle') {
      _u.status = 'upload'
      for (const upload of _uploader.getUploads()) {
        _u.submits.push({
          file: _uploader.getFile(upload.id)
        })
      }
      _u.handle.call()
    }
    _next()
    return false
  }
  function _submits() {
    return _u.submits
  }
  function _add(submits) {
    _uploader.addFiles(submits)
  }
  function _get() {
    return _uploader
  }
  function _create(options) {
    /**
     * After mount create fineuploader on options.target.
     * OnUpload fires _upload()
     *
     * Requires:
     * options.context (this)
     * options.target (selector)
     * options.handle (function to handle submits)
     */
    _u.handle = typeof options.handle === 'function' ? options.handle : () => {}
    const tempTemplateEl = document.createElement('div')
    if (options.context.$el.querySelector(options.target)) {
      tempTemplateEl.appendChild(qq.toElement(options.context.$el.querySelector(options.target).innerHTML))
      _uploader = new qq.FineUploader({
        debug: false,
        template: tempTemplateEl,
        element: options.context.$el.querySelector(options.target),
        callbacks: {
          onSubmit: _upload,
          onStatusChange: _done
        }
      })
    }
  }
  function _destroy() {
    _uploader = null
  }
  return {
    create: _create,
    getSubmits: _submits,
    addSubmits: _add,
    get: _get,
    destroy: _destroy
  }
}

export { UploadObject }
